var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.572 5.70004H5.42816C5.24072 5.69994 5.05509 5.73675 4.88187 5.80839C4.70866 5.88002 4.55125 5.98507 4.41863 6.11753C4.28602 6.25 4.18079 6.40729 4.10896 6.58043C4.03713 6.75356 4.00011 6.93915 4 7.12659V16.8736C4.00011 17.061 4.03713 17.2466 4.10896 17.4198C4.18079 17.5929 4.28602 17.7501 4.41864 17.8826C4.55126 18.0151 4.70867 18.1201 4.88189 18.1917C5.0551 18.2633 5.24073 18.3001 5.42816 18.3H29.572C29.7595 18.3001 29.9451 18.2633 30.1183 18.1916C30.2914 18.12 30.4488 18.015 30.5814 17.8825C30.714 17.7501 30.8192 17.5928 30.8911 17.4197C30.9629 17.2466 30.9999 17.061 31 16.8736V7.12659C30.9998 6.74807 30.8492 6.38513 30.5814 6.11761C30.3137 5.85008 29.9506 5.69988 29.572 5.70004Z",
    fill: "url(#paint0_linear_30169_51)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2649 8.53261C14.2649 8.91143 14.1144 9.27474 13.8466 9.54261C13.5787 9.81048 13.2154 9.96097 12.8366 9.96097C12.4577 9.96097 12.0944 9.81048 11.8266 9.54261C11.5587 9.27474 11.4082 8.91143 11.4082 8.53261C11.4082 8.15378 11.5587 7.79047 11.8266 7.52261C12.0944 7.25474 12.4577 7.10425 12.8366 7.10425C13.2154 7.10425 13.5787 7.25474 13.8466 7.52261C14.1144 7.79047 14.2649 8.15378 14.2649 8.53261Z",
    fill: "url(#paint1_linear_30169_51)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2506 16.6229H27.3073L24.8363 13.4315L27.077 10.6892H25.2115L23.0111 13.4486V7.56428H21.4141V16.6229H23.0111L23.0099 13.4563L25.2506 16.6229ZM18.4018 10.6882H19.9984V16.6219H18.4018V10.6882ZM15.3883 7.56247H16.9849V16.6219H15.3883V7.56247ZM11.2372 10.629C10.7374 10.6283 10.2451 10.7518 9.80484 10.9885V7.56267H8.20801V13.657C8.20785 14.256 8.38534 14.8417 8.71804 15.3399C9.05073 15.8381 9.52369 16.2264 10.0771 16.4558C10.6305 16.6852 11.2395 16.7453 11.8271 16.6285C12.4147 16.5118 12.9544 16.2234 13.3781 15.7999C13.8018 15.3764 14.0904 14.8368 14.2073 14.2492C14.3243 13.6617 14.2644 13.0527 14.0353 12.4992C13.8061 11.9457 13.418 11.4726 12.9199 11.1397C12.4219 10.8068 11.8363 10.6291 11.2372 10.629ZM11.2372 15.1148C10.949 15.1148 10.6672 15.0293 10.4275 14.8691C10.1878 14.709 10.0009 14.4813 9.89062 14.215C9.78029 13.9487 9.75142 13.6556 9.80764 13.3729C9.86386 13.0902 10.0027 12.8304 10.2065 12.6266C10.4103 12.4227 10.67 12.2839 10.9527 12.2276C11.2355 12.1714 11.5285 12.2002 11.7949 12.3105C12.0612 12.4208 12.2889 12.6076 12.4491 12.8472C12.6092 13.0869 12.6948 13.3687 12.6948 13.657C12.6949 13.8484 12.6572 14.038 12.584 14.2149C12.5108 14.3918 12.4034 14.5525 12.2681 14.6879C12.1327 14.8233 11.972 14.9307 11.7951 15.0039C11.6183 15.0771 11.4287 15.1148 11.2372 15.1148Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30169_51",
    x1: 17.5001,
    y1: 18.2393,
    x2: 17.5001,
    y2: 5.7607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30169_51",
    x1: 11.8262,
    y1: 9.54302,
    x2: 13.847,
    y2: 7.5222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94F96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlik);
export default __webpack_public_path__ + "static/media/blik.a69e72db.svg";
export { ForwardRef as ReactComponent };